import { render, staticRenderFns } from "./projectAreaDetail.vue?vue&type=template&id=66d7b646&scoped=true&"
import script from "./projectAreaDetail.vue?vue&type=script&lang=js&"
export * from "./projectAreaDetail.vue?vue&type=script&lang=js&"
import style0 from "./projectAreaDetail.vue?vue&type=style&index=0&id=66d7b646&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d7b646",
  null
  
)

export default component.exports